// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-container[data-v-55f9c869]{background-color:#fff;color:#000;width:655px;border-radius:20px;padding:20px;padding-top:10px;webkit-box-shadow:3px 5px 6px 0 rgb(0 0 0/41%);box-shadow:3px 5px 6px 0 rgb(0 0 0/41%);z-index:99}.uploader_field[data-v-55f9c869]{justify-content:center!important}", ""]);
// Exports
module.exports = exports;
